<template>
  <div class="choose-input-wraper">
    <div class="tab">
      <p
        v-for="(car,idx) in formItem.options"
        :key="idx"
        :class="{selectTab:car.option_type===curType}"
        @click="changeType(car.option_type)"
      >{{car.tip}}</p>
    </div>
    <div
      v-for="(car,idx) in formItem.options"
      :key="idx"
      v-show="car.option_type===curType"
      class="input-content"
    >
      <p v-show="car.value" class="tip">{{car.title}}</p>

      <input
        :class="{'has-val':car.value||car.field_result}"
        type="tel"
        :placeholder="car.title"
        v-model="car.value"
        @input="formatInput(car)"
        @blur="validInput(car)"
        :ref="'input_'+car.option_type"
        :maxlength="car.max_length"
        :disabled="formItem.field_status==4"
      >
      <p
        v-show="car.field_result"
        :class="['status-tip','tip_'+car.field_status ]"
      >{{car.field_result}}</p>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { post } from "../../tools/request";
import { formatCPFBr, formatCNPJBr, emitFormUpdate } from "../../tools/utils";
export default {
  //cm means commit
  props: ["formItem", "idx", "cm"],
  computed: {
    ...mapState(["_ticket"])
  },
  data() {
    return {
      curType: ""
    };
  },
  created() {
    //match current select
    this.curType = this.formItem.value;
    let cur =
      this.formItem.options.find(x => x.option_type == this.curType) || {};
    this.formatInput(cur, "init");
  },
  methods: {
    formatCPFBr,
    formatCNPJBr,
    changeType(t) {
      this.curType = t;
    },
    validInput(car) {
      //Input 依据，regex，valid_api 依次校验，
      let reg = car.regex,
        valid_api = car.valid_api;
      if (reg) {
        let r = new RegExp(reg);
        if (r.test(car.value)) {
          //正则校验通过
          car.field_result = "";
          if (valid_api) {
            // icon 更新--->>checking
            car.field_status = 3;
            car.field_result = this.$t("检测中");
            this.vaildApi(car);
          } else {
            // icon --->> none
            car.field_result = "";
            this.checkCommit(car);
          }
        } else {
          // icon --->> fail
          car.field_status = 5;
          car.field_result = car.regex_remind;
          this.formItem.valid = false;
          emitFormUpdate(this, this.idx);
        }
      } else if (valid_api) {
        // icon 更新--->>checking
        car.field_status = 3;
        car.field_result = this.$t("检测中");
        this.vaildApi(car);
      } else {
        this.checkCommit(car);
      }
    },
    vaildApi(car) {
      let up = new URLSearchParams(location.search);
      //兼容各个国家情况，vuex中如果存在ticket，则优先信任
      if (this._ticket) {
        up.set("ticket", this._ticket);
      }
      let val = car.value;
      if (car.clear_format) {
        val = this[car.format](val, true);
      }
      up.append("value", val);
      post(car.valid_api, up)
        .then(() => {
          //提交数据,通过后如果需要直接提交则提交数据
          car.field_result = "";
          this.checkCommit(car);
        })
        .catch(res => {
          // icon 更新-->> fail
          car.field_status = 5;
          car.field_result = res.errmsg;
          this.formItem.valid = false;
          emitFormUpdate(this, this.idx);
        });
    },
    formatInput(car, action = "input") {
      //首先尝试进行格式化
      let format = car.format;
      if (format) {
        car.value = this[format](car.value);
      }
      if (!car.regex && !car.valid_api) {
        this.formItem.valid = true;
      }
      emitFormUpdate(this, this.idx);
      //解决端内触发blur函数的bug
      if (action === "init") {
        return;
      }
      setTimeout(() => {
        let dom = this.$refs["input_" + car.option_type] || {};
        let start = dom.selectionStart,
          len = car.value.length;
        // 兼容手机光标移位问题
        dom.selectionStart = len+50;
        dom.selectionEnd = len+50;
      }, 0);
    },
    checkCommit(car) {
      //if need add
      if (this.cm) {
        this.addInfo(car);
      } else {
        this.formItem.valid = true;
        emitFormUpdate(this, this.idx, car);
      }
    },
    //提交物料
    addInfo(car) {
      // 更新icon --checking
      car.field_status = 3;
      car.field_result = this.$t("检测中");
      let up = new URLSearchParams(location.search);
      //兼容各个国家情况，vuex中如果存在ticket，则优先信任
      if (this._ticket) {
        up.set("ticket", this._ticket);
      }
      let val = car.value;
      if (car.clear_format) {
        val = this[car.format](val, true);
      }
      up.append(this.formItem.key, this.curType);
      up.append(car.key, val);
      post(process.env.ADD_AUDI_INFO, up)
        .then(() => {
          // success do nothing,wait for loop
        })
        .catch(err => {
          car.field_status = 5;
          car.field_result = err.errmsg;
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.choose-input-wraper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  min-height: 2.36rem;
  box-sizing: border-box;
  padding: 0 0.24rem 0 0.4rem;
  margin-bottom: 0.12rem;
  font-weight: 400;
  background: #fff;
  .tip {
    font-size: 0.28rem;
    line-height: 0.48rem;
    color: #646466;
  }
  input {
    width: 90%;
  }
  .has-val {
    margin: 0.2rem 0;
  }
  .tab {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 1.2rem;
    p {
      position: relative;
      height: 0.54rem;
      box-sizing: border-box;
      padding: 0.1rem 0.14rem;
      font-size: 0.28rem;
      line-height: 0.34rem;
      color: #999;
      &:after {
        position: absolute;
        bottom: 0;
        left: 0;
        content: "";
        width: 200%;
        height: 200%;
        border: 1px solid #d1d1d1;
        border-radius: 0.08rem;
        transform: scale(0.5);
        transform-origin: left bottom;
      }
      & + p {
        margin-left: 0.24rem;
      }
      &.selectTab {
        color: #00b0ff;
        &:after {
          border: 1px solid #00b0ff;
        }
      }
    }
    &:after {
      position: absolute;
      left: -0.4rem;
      bottom: 0;
      content: "";
      width: 7.5rem;
      border-bottom: 1px solid #e1e2e6;
      transform: scaleY(0.5);
    }
  }
  .input-content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-height: 1.4rem;
  }
}
</style>
